import { baseAPI } from "../baseApi";

export const helpApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        getApplicationInfo: builder.query<any, any>({
            query: () => ({
                url: "help/application"
            })
        })
    })
})

export const {
    useLazyGetApplicationInfoQuery
} = helpApiSlice